import { IconTypesProps } from './iconTypes'

const SvgStatusCritical = ({
    primaryColor = '#010101',
    secondaryColor = '#D31D1A',
    reverse,
    dataTestId,
    width,
    height,
}: IconTypesProps) => {
    if (reverse) {
        const tempPrimaryColor = primaryColor
        primaryColor = secondaryColor
        secondaryColor = tempPrimaryColor
    }
    return (
        <svg
            width={width || '24'}
            height={height || '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={dataTestId}
        >
            <circle cx="12" cy="12" r="12" fill={secondaryColor} />
            <rect
                x="6"
                y="10.875"
                width="12"
                height="2.25"
                fill={primaryColor}
            />
        </svg>
    )
}

export default SvgStatusCritical
